import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './components/Login';
import Register from './components/Register';
import Layout from './components/Layout';
// DISABLED 2026-07-08 to reduce server load — uncomment to re-enable these pages.
// import Dashboard from './pages/Dashboard';
// import ShortAndLong from './pages/ShortAndLong';
import DBMonitor from './pages/DBMonitor';
import ServerMonitor from './pages/ServerMonitor';
import SP500Market from './pages/SP500Market';
// import SP500PreMarket from './pages/SP500PreMarket';
import Options from './pages/Options';
import NVDASwing from './pages/NVDASwing';
import { isTokenExpired } from './utils/auth';

function NotFoundRedirect() {
  const token = localStorage.getItem('token');
  const loggedIn = token && !isTokenExpired(token);
  return <Navigate to={loggedIn ? '/dashboard' : '/'} replace />;
}

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route element={<Layout />}>
          {/* DISABLED 2026-07-08 to reduce server load — restore the original
              routes below (and the imports above) to re-enable these pages.
              /dashboard redirects so login and old bookmarks still land somewhere. */}
          {/* <Route path="/dashboard" element={<Dashboard />} /> */}
          {/* <Route path="/short-and-long" element={<ShortAndLong />} /> */}
          {/* <Route path="/sp500-premarket" element={<SP500PreMarket />} /> */}
          <Route path="/dashboard" element={<Navigate to="/sp500-market" replace />} />
          <Route path="/sp500-market" element={<SP500Market />} />
          <Route path="/options" element={<Options />} />
          <Route path="/nvda-swing" element={<NVDASwing />} />
          <Route path="/monitor/db" element={<DBMonitor />} />
          <Route path="/monitor/server" element={<ServerMonitor />} />
        </Route>
        <Route path="*" element={<NotFoundRedirect />} />
      </Routes>
    </Router>
  );
}

export default App;
